import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Cloudflare congratulates SurveyMonkey on  their rebrand and launches MonkeyFlare!
    
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
        </a>
      </header>
    </div>
  );
}

export default App;
